var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3099 1C6.97065 1 1 6.25667 1 12.7187C1 15.4485 2.08264 18.0936 4.05297 20.1902C4.44293 21.7947 3.96962 23.4945 2.79521 24.6664C2.30416 25.1564 2.65142 26 3.3488 26C5.57985 26 7.73062 25.128 9.32859 23.5899C10.9097 24.1529 12.5827 24.4375 14.3099 24.4375C21.6491 24.4375 27.7241 19.1808 27.7241 12.7187C27.7241 6.25667 21.6491 1 14.3099 1ZM8.15079 15.0625C6.85561 15.0625 5.80199 14.0111 5.80199 12.7187C5.80199 11.4264 6.85561 10.375 8.15079 10.375C9.44598 10.375 10.4996 11.4264 10.4996 12.7187C10.4996 14.0111 9.44598 15.0625 8.15079 15.0625ZM14.4143 15.0625C13.1191 15.0625 12.0655 14.0111 12.0655 12.7187C12.0655 11.4264 13.1191 10.375 14.4143 10.375C15.7094 10.375 16.7631 11.4264 16.7631 12.7187C16.7631 14.0111 15.7094 15.0625 14.4143 15.0625ZM20.6777 15.0625C19.3826 15.0625 18.3289 14.0111 18.3289 12.7187C18.3289 11.4264 19.3826 10.375 20.6777 10.375C21.9729 10.375 23.0265 11.4264 23.0265 12.7187C23.0265 14.0111 21.9729 15.0625 20.6777 15.0625Z",
    stroke: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatUnselected);
export default __webpack_public_path__ + "static/media/chat_unselected.60a13122aba56e28a15191561a4dfbea.svg";
export { ForwardRef as ReactComponent };